// What each portal tab is for -- shown as the tab's tooltip in the portal tab bar (Scott,
// 2026-10-05: on the tab, not as a list on the landing page). Only enabled tabs render.
export const TAB_GUIDE = {
  overview:     'This page: findings that need attention and a workforce snapshot.',
  organization: 'Your organization structure, locations and where people work.',
  metrics:      'Workforce, pay and talent metrics, each with a drill-down to the people behind it.',
  compliance:   'Pay and employment compliance checks and what they found.',
  health:       'Data and configuration quality issues in your system.',
  system:       'How your system is set up: companies, org levels, earning and deduction groups.',
  datamap:      'How the tables in your data link to each other, and which ones stand alone.',
  contract:     'Your contract lines and the usage counted against them.',
}

// Who a customer contacts -- customer-facing copy says "Account Representative".
export const CONTACT_LINE = 'Questions about anything here? Contact your Sempirical Account Representative.'
